import _ from 'lodash';
import { t } from '@lingui/macro';
import { i18n } from '@lingui/core';

export const AND = 'AND';
export const OR = 'OR';
export const title = t`Tags`;

export const TAG_OP_SUMMARIES = {
    [AND]: t`All`,
    [OR]: t`Any`,
};

export default function TagFilterStateServiceFactory(filterId) {
    const TagFilterStateService = {
        /*
         * Factory functions
         */

        createWithEncodedState(encodedState) {
            return TagFilterStateService.decode(encodedState);
        },

        createWithDefaultState() {
            return {
                tags: [],
                tagOp: AND,
            };
        },

        createState(encodedFilterState, dataService) {
            const encodedState = encodedFilterState?.[filterId];
            return encodedState
                ? this.createWithEncodedState(encodedState, dataService)
                : this.createWithDefaultState(dataService);
        },

        /*
         * Transformation functions
         */

        parameterize(state) {
            return {
                tags: TagFilterStateService.encode(state),
            };
        },

        encode(state) {
            return JSON.stringify(state);
        },

        decode(encodedState) {
            const state = JSON.parse(encodedState);
            if (_.isArray(state)) {
                return {
                    tags: state,
                    tagOp: AND,
                };
            }
            return state;
        },

        summarize(state) {
            const { tags, tagOp } = state;
            const summary = `${i18n._(TAG_OP_SUMMARIES[tagOp])}: ${tags.join(', ')}`;
            return {
                title,
                value: summary,
                shortValue: summary,
            };
        },
    };

    return TagFilterStateService;
}
